export const buildMonthlyAnalytics = ({ todos = [], roachEntries = [] }) => {
    const total = todos.length;
    const done = todos.filter((t) => t.status === "Done").length;
    const cancelled = todos.filter((t) => t.status === "Cancelled").length;
    const planned = todos.filter((t) => t.status === "Planned").length;

    const productivityScore = total ? Math.round((done / total) * 100) : 0;

    // OBJECTIVES
    const objectiveMap = {};
    todos.forEach((t) => {
        const key = t.objective || "Unknown";
        objectiveMap[key] = (objectiveMap[key] || 0) + 1;
    });

    // TREND
    const trend = [0, 0, 0, 0, 0, 0, 0];

    todos.forEach((t) => {
        const d = new Date(t.createdAt).getDay();
        const index = d === 0 ? 6 : d - 1;

        if (t.status === "Done") trend[index] += 15;
        if (t.status === "Planned") trend[index] += 8;
        if (t.status === "Cancelled") trend[index] -= 5;
    });

    const normalizedTrend = trend.map((v) =>
        v < 0 ? 0 : v > 100 ? 100 : v
    );

    const days = [
        "Monday","Tuesday","Wednesday","Thursday",
        "Friday","Saturday","Sunday"
    ];

    const bestDayIndex = normalizedTrend.indexOf(Math.max(...normalizedTrend));
    const weakDayIndex = normalizedTrend.indexOf(Math.min(...normalizedTrend));

    // ROACH
    const avgRoachScore = roachEntries.length
        ? roachEntries.reduce((acc, c) => acc + (c.avgScore || 0), 0) / roachEntries.length
        : 0;

    const latestRoach = roachEntries[roachEntries.length - 1] || null;

    // SIGNALS
    const focusScore = Math.min(
        100,
        Math.round(
            (((objectiveMap.Build || 0) +
                (objectiveMap.Focus || 0) +
                (objectiveMap.Learning || 0)) /
                Math.max(total, 1)) *
                100
        )
    );

    const consistencyScore = Math.min(
        100,
        Math.round((done / Math.max(done + cancelled, 1)) * 100)
    );

    const disciplineScore = Math.min(
        100,
        Math.round((done / Math.max(total, 1)) * 100)
    );

    const resilienceScore = Math.min(
        100,
        Math.round((avgRoachScore / 9) * 100)
    );

    // WEAKNESSES
    const weaknesses = [];

    if (cancelled >= 3) weaknesses.push("High distraction frequency");
    if ((objectiveMap.Random || 0) >= 4) weaknesses.push("Too many random objectives");
    if (focusScore < 45) weaknesses.push("Low deep-work focus");
    if (consistencyScore < 50) weaknesses.push("Weak consistency pattern");
    if (avgRoachScore < 4) weaknesses.push("Behavior stability dropping");

    if (!weaknesses.length) weaknesses.push("No major weaknesses detected");

    return {
        score: productivityScore,
        stats: { total, done, planned, cancelled },
        trend: normalizedTrend,
        bestDay: days[bestDayIndex],
        weakDay: days[weakDayIndex],
        objectives: objectiveMap,
        signals: {
            focus: focusScore,
            consistency: consistencyScore,
            discipline: disciplineScore,
            resilience: resilienceScore,
        },
        weaknesses,
        roach: {
            avgScore: avgRoachScore,
            type: latestRoach?.type || "Unknown Survivor",
        },
    };
};